import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { LineupStore } from 'stores/LineupStore';
import { HomeplateImage } from '../HomeplateSection/HomeplateImage';
import { useHomePlate } from '../hooks/useHomePlate';
import { Description, Divider, HeightOffset, HeightOffsetList, Title, Wrapper } from './OfficialHomeplateSectionStyles';
enum TitleNumber {
  'One' = 1,
  'Two',
  'Three',
}

export const OfficialHomeplateSection = observer(() => {
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);
  const { getDescription, getOffsetValue, getExtensionValue } = useHomePlate();

  return (
    <Wrapper>
      <HomeplateImage />
      <div>
        {lineupStore.league.strikeZoneCalculationInformations?.length && (
          <Title>{TitleNumber[lineupStore.league.strikeZoneCalculationInformations?.length]} section SZ</Title>
        )}
        <Description>{getDescription()}</Description>
        <HeightOffsetList>
          {lineupStore.league.strikeZoneCalculationInformations
            ?.filter((calculation) => calculation.offset !== 0 && calculation.offset !== '0.0')
            ?.map((calculation, index) => {
              return (
                <>
                  <HeightOffset>
                    Height offset at the {calculation.strikeZoneCalculationType} <span>{getOffsetValue(calculation)}</span>
                  </HeightOffset>
                  {index > 0 && <Divider />}
                </>
              );
            })}
          {lineupStore.league.strikeZoneCalculationInformations
            ?.filter((calculation) => calculation.extension !== 0 && calculation.extension !== '0.0')
            ?.map((calculation, index) => {
              return (
                <>
                  <HeightOffset>
                    Extension at the {calculation.strikeZoneCalculationType} <span>{getExtensionValue(calculation)}</span>
                  </HeightOffset>
                  {index > 0 && <Divider />}
                </>
              );
            })}
        </HeightOffsetList>
      </div>
    </Wrapper>
  );
});
